import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "q-pa-md q-gutter-sm items-center justify-end" }
const _hoisted_2 = /*#__PURE__*/_createVNode("strong", null, "ATENCIÓN:", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Se debe tener en cuenta que las asignaciones realizadas por sorteo no se hacen efectivas hasta que el juzgado notifica al auxiliar. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_banner = _resolveComponent("q-banner")
  const _component_filtros_asignaciones = _resolveComponent("filtros-asignaciones")
  const _component_listado_asignaciones = _resolveComponent("listado-asignaciones")
  const _component_busqueda_con_filtros = _resolveComponent("busqueda-con-filtros")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_q_banner, {
        "inline-actions": "",
        rounded: "",
        class: "bg-orange text-white text-center"
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_busqueda_con_filtros, {
      loading: _ctx.loading,
      page: _ctx.page,
      filtro: _ctx.filtro,
      titulo: _ctx.titulo,
      "show-busqueda": _ctx.showListado,
      onLimpiar: _ctx.limpiar,
      onBuscar: _ctx.buscar,
      onDescargar: _ctx.descargar,
      tieneDescarga: ""
    }, {
      filtros: _withCtx(({ filtro }) => [
        _createVNode(_component_filtros_asignaciones, {
          ref: "filtroComponent",
          filtro: filtro
        }, null, 8, ["filtro"])
      ]),
      listados: _withCtx(({ loading, pagination, data }) => [
        _createVNode(_component_listado_asignaciones, {
          loading: loading || _ctx.loadingListado,
          asignaciones: data,
          pagination: pagination,
          onPagination: _ctx.buscar
        }, null, 8, ["loading", "asignaciones", "pagination", "onPagination"])
      ]),
      _: 1
    }, 8, ["loading", "page", "filtro", "titulo", "show-busqueda", "onLimpiar", "onBuscar", "onDescargar"])
  ], 64))
}